import { render, staticRenderFns } from "./index.vue?vue&type=template&id=21d74f8e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=21d74f8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d74f8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/h5-web-gold/h5-web-gold/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21d74f8e')) {
      api.createRecord('21d74f8e', component.options)
    } else {
      api.reload('21d74f8e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=21d74f8e&scoped=true&", function () {
      api.rerender('21d74f8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pricingRecords/index.vue"
export default component.exports